<div
  class="floating-fields-wrapper forceDefaultColors"
  [class.dragging]="isDraggingField"
  [class.resizing]="isResizingField"
  (mousemove)="onDragField($event)"
  (mouseup)="onStopSelectedField()"
  (mouseleave)="onStopSelectedField()"
  (touchmove)="onDragField($event)"
  (touchend)="onStopSelectedField()"
  (touchcancel)="onStopSelectedField(); selectField(null)"
>
  @for (field of parsedFields; track fieldIdentifier($index, field)) {
    <div
      class="floating-field-shell"
      [ngStyle]="field.styles"
      [style.z-index]="field.isSelected ? 20 : 10"
      [ngClass]="{
        newSignatureStyle: field.element === PositionElementEnum.Signature && isNewSignatureStyle,
        'border-advanced': field.borderType === FloatingFieldBorderType.Advanced,
        'border-icp': field.borderType === FloatingFieldBorderType.NationalCertificate,
        'border-certificate': field.borderType === FloatingFieldBorderType.InternationalCertificate
      }"
    >
      <div
        class="floating-field {{ (field.signature?.font || '').toLowerCase() }}"
        [class.selected]="field.isSelected"
        [class.edit-mode]="enableEdit && !field.signature"
        [ngStyle]="field.innerStyles"
        (mousedown)="onStartDraggingField($event, field)"
        (mouseenter)="selectField(field.originalField)"
        (mouseleave)="selectField(null)"
        (touchstart)="onStartDraggingField($event, field); selectField(field.originalField)"
        (touchend)="onStopRotateField()"
        (touchcancel)="onStopRotateField()"
      >
        @if (field.signature && !field.idColor) {
          @if (!field.element || field.element === PositionElementEnum.Signature) {
            <div class="signature-content">
              <div [ngClass]="{ 'signature-newSignatureStyle': isNewSignatureStyle }">
                @if (isNewSignatureStyle && isDocumentWhitelabelLoaded) {
                  <div class="signature-newSignatureStyle__img">
                    <img alt="" [src]="documentWhitelabel?.pdf_logo_mini" />
                  </div>
                }
                <div class="" [ngClass]="{ 'signature-newSignatureStyle__content': isNewSignatureStyle }">
                  @if (currentFormat(field) === SignatureFormat.Eletronic && !isNewSignatureStyle) {
                    <div class="signature-eletronic mt-2">
                      {{ 'signature.electronicallySigned' | translate }}
                    </div>
                  }
                  @if (
                    currentFormat(field) === SignatureFormat.Handwriting ||
                    (currentFormat(field) === SignatureFormat.Image && !field.signature.signatureImageUrl) ||
                    (currentFormat(field) === SignatureFormat.Draw && !field.signature.signatureDrawImageUrl)
                  ) {
                    <div class="signature-handwriting">
                      {{ field.signature?.signatureText ? field.signature.signatureText : (field.signature.name | signatureName) }}
                    </div>
                  }
                  @if (
                    (currentFormat(field) === SignatureFormat.Image && field.signature.signatureImageUrl) || (currentFormat(field) === SignatureFormat.Draw && field.signature.signatureDrawImageUrl)
                  ) {
                    <div
                      class="signature-image"
                      [ngStyle]="{ backgroundImage: 'url(' + (currentFormat(field) === SignatureFormat.Image ? field.signature.signatureImageUrl : field.signature.signatureDrawImageUrl) + ')' }"
                    ></div>
                  }
                  @if (isNewSignatureStyle) {
                    <div class="signature-newSignatureStyle-qualifiedBy">
                      {{ (field.borderType === FloatingFieldBorderType.Advanced ? 'signature.electronicallySignedBy' : 'signature.qualifiedSignatureBy') | translate }}
                    </div>
                    <div class="signature-newSignatureStyle-name">{{ field.signature.certificate?.name || field.signature.name | signatureNewStyleName }}</div>
                    <div class="signature-newSignatureStyle-date">
                      {{
                        ('signature.dateLabel' | translate) +
                          (field.signature.createdAt | ldate: dateFormat : timezone : language) +
                          ' ' +
                          (field.signature.createdAt | ldate: (dateFormat == 'dd/MM/yyyy' ? 'HH:mm' : 'h:mm a') : timezone : language)
                      }}
                    </div>
                    <div class="signature-newSignatureStyle-id">{{ '#' + field.signature.publicId }}</div>
                    <div class="signature-newSignatureStyle-action">{{ documentService.translateRole(field.signature.actionName) }}</div>
                    @if (field.borderType === FloatingFieldBorderType.NationalCertificate) {
                      <div class="signature-newSignatureStyle-icp-overlay">
                        <img src="assets/logo-icp-side.png" alt="" />
                      </div>
                    }
                    @if (field.borderType === FloatingFieldBorderType.InternationalCertificate) {
                      <div class="signature-newSignatureStyle-certificate-overlay">
                        <i class="fas fa-key-skeleton-left-right"></i>
                        <span>{{ 'signature.qualifiedSignatureTitle' | translate }}</span>
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          }
          @if (field.element === PositionElementEnum.Initials) {
            <div class="signature-content">
              @if (currentFormat(field) === SignatureFormat.Eletronic) {
                <div class="signature-handwriting initials eletronic">
                  {{ field.signature.initialsText ? field.signature.initialsText : (field.signature.name | initialsName) }}
                </div>
              }
              @if (
                currentFormat(field) === SignatureFormat.Handwriting ||
                (currentFormat(field) === SignatureFormat.Image && !field.signature.initialsImageUrl) ||
                (currentFormat(field) === SignatureFormat.Draw && !field.signature.initialsDrawImageUrl)
              ) {
                <div class="signature-handwriting initials">
                  {{ field.signature.initialsText ? field.signature.initialsText : (field.signature.name | initialsName) }}
                </div>
              }
              @if ((currentFormat(field) === SignatureFormat.Image && field.signature.initialsImageUrl) || (currentFormat(field) === SignatureFormat.Draw && field.signature.initialsDrawImageUrl)) {
                <div
                  class="signature-image"
                  [ngStyle]="{ backgroundImage: 'url(' + (currentFormat(field) === SignatureFormat.Image ? field.signature.initialsImageUrl : field.signature.initialsDrawImageUrl) + ')' }"
                ></div>
              }
            </div>
          }
          @if (field.element === PositionElementEnum.Name) {
            <div class="signature-content text-left">
              <div>
                <span class="signature-name">{{ field.signature.name || ('signature.name' | translate) }}</span>
                @if (!field.signature.name && field.signature.email) {
                  <span>&nbsp;({{ field.signature.email }})</span>
                }
              </div>
            </div>
          }
          @if (field.element === PositionElementEnum.Cpf && field.signature.cpf) {
            <div class="signature-content text-left">
              <span class="signature-name">{{ field.signature.cpf }}</span>
            </div>
          }
          @if (field.element === PositionElementEnum.Date) {
            <div class="signature-content text-left">
              <span class="signature-name">{{ field.signature.createdAt ? (field.signature.createdAt | ldate: 'longDate' : timezone : language) : ('signature.signatureDate' | translate) }}</span>
            </div>
          }
        }

        @if (field.idColor) {
          @if (field.isSelected) {
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="resize"
              (mousedown)="onStartResizeField($event, field, 'right_bottom')"
              (touchstart)="onStartResizeField($event, field, 'right_bottom')"
            >
              <line x1="4" y1="12" x2="12" y2="4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              <line x1="8" y1="12" x2="12" y2="8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg>
          }
          <div
            class="rotate"
            [ngClass]="{ active: field.canRotate }"
            (mousedown)="onStartRotateField($event, field)"
            (touchstart)="onStartRotateField($event, field)"
            (touchend)="onStopRotateField(); selectField(null)"
          >
            <div class="rotate-control"><i class="fa-regular fa-sync-alt"></i></div>
          </div>
          @if (field.element === PositionElementEnum.Signature) {
            <div class="signature-content" [class.newSignatureStyle]="isNewSignatureStyle">
              <div class="signature-empty"><i class="fal fa-signature"></i> {{ 'signature.signature' | translate }}</div>
            </div>
          }
          @if (field.element === PositionElementEnum.Initials) {
            <div class="signature-content">
              <div class="signature-empty"><i class="fal fa-spell-check"></i> {{ 'signature.initials' | translate }}</div>
            </div>
          }
          @if (field.element === PositionElementEnum.Name) {
            <div class="signature-content">
              <div class="signature-empty"><i class="fal fa-user"></i> {{ 'signature.name' | translate }}</div>
            </div>
          }
          @if (field.element === PositionElementEnum.Cpf) {
            <div class="signature-content">
              <div class="signature-empty"><i class="fa-regular fa-id-card"></i> {{ 'signature.cpf' | translate }}</div>
            </div>
          }
          @if (field.element === PositionElementEnum.Date) {
            <div class="signature-content">
              <div class="signature-empty"><i class="fal fa-calendar-day"></i> {{ 'signature.signatureDate' | translate }}</div>
            </div>
          }
        }
        <div class="floating-field-options">
          @if (!qualified && !field.originalField.signerQualified) {
            @if (field.originalField.idLink) {
              <div class="floating-field-option" (click)="unlinkField(field)" [ngbTooltip]="tooltipUnlink" container="body" [placement]="returnPlacementTooltip(field)">
                <i class="fal fa-link-simple-slash"></i>
              </div>
              <div class="floating-field-option" (click)="unlinkFields(field.originalField)" [ngbTooltip]="tooltipUnlinkAll" container="body" [placement]="returnPlacementTooltip(field)">
                <i class="fal fa-link-horizontal-slash"></i>
              </div>
            }
            @if (!field.originalField.idLink) {
              <div class="floating-field-option" (click)="openRepeatFieldModal(field.originalField)" [ngbTooltip]="tooltipRepeat" container="body" [placement]="returnPlacementTooltip(field)">
                <i class="fal fa-copy"></i>
              </div>
            }
          }
          <div class="floating-field-option" (click)="removeField(field.originalField)" [ngbTooltip]="tooltipClose" container="body" [placement]="returnPlacementTooltip(field)">
            <i class="fal fa-times"></i>
          </div>
        </div>
      </div>
    </div>
  }
</div>

<ng-template #tooltipUnlink>{{ 'signature.unlink' | translate }}</ng-template>
<ng-template #tooltipUnlinkAll>{{ 'signature.unlinkAll' | translate }}</ng-template>
<ng-template #tooltipRepeat>{{ 'signature.repeat' | translate }}</ng-template>
<ng-template #tooltipClose>{{ 'signature.remove' | translate }}</ng-template>
